// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"868":"2b67dd3c","2424":"fb768bd7","3057":"2c9e8ac6","5050":"e36eb67d","6178":"a07ead93"}[chunkId] + ".chunk.css";
};